var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHourglassSimpleHigh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HourglassSimpleHigh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4988 15.3562L10.9043 10L16.4988 4.64375C16.502 4.64017 16.5054 4.63678 16.509 4.63359C16.6837 4.45878 16.8027 4.2361 16.8508 3.9937C16.899 3.7513 16.8743 3.50006 16.7797 3.27172C16.6851 3.04339 16.525 2.84821 16.3196 2.71085C16.1141 2.57349 15.8725 2.50011 15.6254 2.5H4.3754C4.12826 2.50011 3.88669 2.57349 3.68124 2.71085C3.47578 2.84821 3.31566 3.04339 3.2211 3.27172C3.12653 3.50006 3.10178 3.7513 3.14996 3.9937C3.19815 4.2361 3.31711 4.45878 3.4918 4.63359C3.49538 4.63678 3.49877 4.64017 3.50196 4.64375L9.09649 10L3.50196 15.3562C3.49877 15.3598 3.49538 15.3632 3.4918 15.3664C3.31711 15.5412 3.19815 15.7639 3.14996 16.0063C3.10178 16.2487 3.12653 16.4999 3.2211 16.7283C3.31566 16.9566 3.47578 17.1518 3.68124 17.2892C3.88669 17.4265 4.12826 17.4999 4.3754 17.5H15.6254C15.8726 17.5 16.1143 17.4268 16.3199 17.2895C16.5254 17.1522 16.6857 16.957 16.7803 16.7286C16.875 16.5003 16.8998 16.249 16.8517 16.0065C16.8035 15.764 16.6845 15.5413 16.5098 15.3664C16.5059 15.3632 16.5023 15.3599 16.4988 15.3562ZM15.6254 3.75L14.3207 5H5.68165L4.3754 3.75H15.6254ZM4.3754 16.25L10.0004 10.8656L15.6254 16.25H4.3754Z",
    fill: "#343330"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHourglassSimpleHigh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HourglassSimpleHigh.e2a09c9e.svg";
export { ForwardRef as ReactComponent };